import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "articledetail" }
const _hoisted_2 = { class: "title" }
const _hoisted_3 = { class: "time" }
const _hoisted_4 = { class: "content flex-1" }

import {useRoute, useRouter} from "vue-router";
import {onMounted, ref} from "vue";
import weChatApi from "@/utils/Api/WeChat";

export default /*@__PURE__*/_defineComponent({
  __name: 'festivaldetail',
  setup(__props) {

const router=useRouter();
const route=useRoute();
onMounted(()=>{
  getData();
})
const form=ref({})
const getData=()=>{
  weChatApi.deathDetail(route.query.id).then(res=>{
    form.value=res.data;
  })
}
const gotoPage=(path:string)=>{
  router.push(path);
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, _toDisplayString(form.value.deceasedname) + "的" + _toDisplayString(form.value.sacrificialdayname) + "祭日", 1),
    _createElementVNode("div", _hoisted_3, "祭日时间：" + _toDisplayString(form.value.sacrificialDayDateExt), 1),
    _createElementVNode("div", _hoisted_4, [
      _createTextVNode(_toDisplayString(form.value.sacrificialdaydesc) + " ", 1),
      _createElementVNode("button", {
        class: "colorful-btn",
        onClick: _cache[0] || (_cache[0] = ($event: any) => (gotoPage('/')))
      }, "返回首页")
    ])
  ]))
}
}

})